import mapObjectToQueryParams from '../mapObjectToQueryParams.js';
import {API_VERSION, BASE_API_URL} from '../utilities.js';
import apiRequests from '../apiRequests.js';
import axios from 'axios';
import dispatchHelper from './dispatchHelper.js';
import { store } from '../../redux/lib/configureStore.js';
import { getToken } from '../authHelpers.js';
import { logoutAndRedirect } from '../../redux/actions/userActions.js';

const handleAPIRequest = async (config) => {
  if (!apiRequests.isAllowed(config)) {
    return;
  }

  const cancelSource = axios.CancelToken.source();
  apiRequests.set({ ...config, cancelSource });
  const actionTypes = Array.isArray(config.action) ? config.action : [config.action];
  const dispatches = actionTypes.map((n) => dispatchHelper(n, store.dispatch));

  try {
    const request = new axios.create({ timeout: 1000 * 60 * 10 });
    let response = await request({
      url: config.url,
      data: config.data,
      crossDomain: config.crossDomain,
      method: config.method,
      headers: {
        ...(config || {}).headers,
        Authorization: config.requiresToken ? `Bearer ${getToken()}` : ((config || {}).headers || {}).Authorization,
      },
      cancelToken: cancelSource.token,
    });

    if (config.modifyResponse) {
      response = config.modifyResponse(response);
    }

    dispatches.forEach((n) => n(response, config.callback, config.meta));
  } catch (error) {
    const authRoute = config.url.includes('login') || config.url.includes('password') || config.url.includes('reset-pw');
    if (((error || {}).request || {}).status === 401 && !authRoute) {
      logoutAndRedirect({ saveRedirectPath: true });
      return;
    }
    const err = error.response || error.request || error;
    dispatches.forEach((n) => n(err, config.callback));
  }

  apiRequests.delete(config.url);
  return cancelSource.cancel;
};

const apiRequest = (method, url, config = {}) => {
  const query = method === 'GET' ? { ...config.query } : {};
  const params = method === 'GET' ? String(mapObjectToQueryParams(query)).slice(1) : '';
  const apiVersion = config.apiVersion ? config.apiVersion : API_VERSION;
  let fixedUrl = String(String(url).match(/^https*:\/\//) ? url : `${BASE_API_URL}/${apiVersion}${url}?${params}`);
  fixedUrl = (fixedUrl || '').endsWith('?') ? fixedUrl.slice(0, -1) : fixedUrl;
  return new Promise((resolve) => {
    const callback = (nothing, data, err) => {
      resolve(data, err);
      if (config.callback && typeof config.callback === 'function') {
        config.callback(data, err);
      }
    };

    handleAPIRequest({
      url: fixedUrl,
      data: config.data,
      headers: config.headers,
      alwaysAllowRequest: config.alwaysAllowRequest,
      crossDomain: config.crossDomain,
      action: config.action,
      meta: config.meta,
      modifyResponse: config.modifyResponse || null,
      requiresToken: config.requiresToken === undefined ? true : config.requiresToken,
      callback,
      method,
    });
  });
};

export default apiRequest;
